// Nativos
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

// Serviços
import { Membro } from '../../_models/membro';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import * as alerts from '../../_functions/alerts';

// Variaveis de icone
const ICONE_OLHO_ABERTO: string = 'assets/images/icons/olho_aberto.png';
const ICONE_OLHO_FECHADO: string = 'assets/images/icons/olho_fechado.png';

@Component({
  selector: 'app-redefinicao-senha',
  templateUrl: './redefinicao-senha.component.html',
  styleUrls: ['./redefinicao-senha.component.scss'],
})
export class RedefinicaoSenhaComponent implements OnInit {
  token: string;
  tokenUrl: string;
  exibeMensagemSenha: boolean = false;
  exibeFormulario: boolean = false;
  membroForm: UntypedFormGroup;
  membro: Membro = new Membro();

  //Variaveis icone de visibilidade
  iconeConfirmarSenha: string = ICONE_OLHO_FECHADO;
  iconeSenha: string = ICONE_OLHO_FECHADO;
  inputConfirmarAlterado: boolean = false;
  inputSenhaAlterado: boolean = false;
  tipoInputConfirmar: string = 'password';
  tipoInput: string = 'password';

  // Variaveis publicas
  validation_cpf: UntypedFormControl;
  validation_senha: UntypedFormControl;
  validation_senhaConfirmacao: UntypedFormControl;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService
  ) {}

  ngOnInit(): void {
    //Obtém o parametro da rota
    this.route.queryParams.subscribe((params) => {
      this.token = params.token;
      
      if(this.token.includes('?utm_source=marketingcloud'))
        this.token = this.token.split('?utm_source=marketingcloud')[0];
      
      this.validarToken();
    });

    this.validation_cpf = new UntypedFormControl(this.membro.cpf, [
      Validators.required,
    ]);

    this.validation_senha = new UntypedFormControl(this.membro.senha, [
      Validators.required,
      Validators.pattern(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
      ),
    ]);

    this.validation_senhaConfirmacao = new UntypedFormControl(
      this.membro.senhaConfirmacao,
      [
        Validators.required,
        Validators.pattern(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\\d$@$!%*?&].{7,}$'
        ),
      ]
    );

    this.membroForm = new UntypedFormGroup({
      cpf: this.validation_cpf,
      senha: this.validation_senha,
      senhaConfirmacao: this.validation_senhaConfirmacao,
    });
  }

  // ** Metodos Privados de APOIO ** //
  private validarToken() {
    if (!this.token) this.router.navigate(['/']);

    this.authService.loginComToken(this.token).subscribe(
      (sucesso) => {
        this.processarSucessoToken(sucesso);
      },
      (falha) => {
        this.processarFalhaToken(falha);
      }
    );
  }

  // ** Metodos Privados de Sucesso e Insucesso ** //
  private processarSucessoToken(response: any) {
    this.tokenUrl = this.token;
    this.exibeFormulario = true;
  }

  private processarFalhaToken(fail: any) {
    alerts.exibirSwal(
      'info',
      'Poxaaa 😥',
      `<div class="text-left"> Esse e-mail não é mais valido, por favor solicite um novo. </div>`
    );

    this.router.navigate(['/esquecisenha']);
  }

  private processarSucessoUpdate(response: any) {
    alerts.exibirSwal(
      'success',
      'Obaaa 😍',
      `<div class="text-left">
            Senha alterada com sucesso!!
                   </div>`,
      'center',
      6000
    );

    this.authService
      .loginComSenha(this.membro.cpf, this.membro.senha)
      .subscribe(
        (sucesso) => this.processarSucesso(sucesso),
        (falha) => this.processarFalha(falha)
      );
  }

  private processarFalhaUpdate(fail: any) {
    const mensagem = ['Token não pertence ao membro informado'];

    if (mensagem.includes(fail)) {
      alerts.exibirSwal(
        'info',
        'Poxaaa 😥',
        `<div class="text-left"> Parece que o CPF não corresponde ao e-mail enviado. </div>`
      );
      return;
    }

    alerts.exibirSwal('error', 'Atenção', fail);
  }

  private processarSucesso(response: any) {
    this.authService.LocalStorage.salvarDadosLocaisUsuario(response);

    this.fidelidadeService.obterMembro().subscribe(
      sucesso => {
        this.authService.LocalStorage.salvarMembro(sucesso);
        this.router.navigate(['/index']);
      });
    }

  private processarFalha(fail: any) {
    console.error(fail);
    this.router.navigate(['/']);
  }

  // ** Função de mudança Inputs ** //
  public alterarTipoInput(campoEscolhido: number) {
    switch (campoEscolhido) {
      case 1:
        if (this.inputSenhaAlterado == true) {
          this.inputSenhaAlterado = false;
          this.iconeSenha = ICONE_OLHO_FECHADO;
          this.tipoInput = 'password';
        } else {
          this.inputSenhaAlterado = true;
          this.iconeSenha = ICONE_OLHO_ABERTO;
          this.tipoInput = 'text';
        }
        break;

      case 2:
        if (this.inputConfirmarAlterado == true) {
          this.inputConfirmarAlterado = false;
          this.iconeConfirmarSenha = ICONE_OLHO_FECHADO;
          this.tipoInputConfirmar = 'password';
        } else {
          this.inputConfirmarAlterado = true;
          this.iconeConfirmarSenha = ICONE_OLHO_ABERTO;
          this.tipoInputConfirmar = 'text';
        }
    }
  }

  // ** Validação de mesma senha ** //
  public validarCoincidenciaSenhas() {
    const paragrafo = <HTMLInputElement>document.getElementById('item-5');
    const classeDefault = 'mt-1 ml-1 mb-2 font-14 label-sem-validacao';

    if (
      this.membroForm.value.senha === this.membroForm.value.senhaConfirmacao &&
      this.membroForm.value.senhaConfirmacao !== null
    ) {
      paragrafo.className = classeDefault + ' font-ativa-senha';
    } else {
      paragrafo.className = classeDefault;
    }
  }

  // ** Metodos publicos de evento de tela ** //
  public onSubmit() {
    if (!this.membroForm.valid) {
      return;
    }

    // Valida se a senha está igual a confirmação
    if (this.validarIgualdadeSenhas()) {
      return;
    }

    // Transferencia de dados
    this.membro.cpf = this.membroForm.value.cpf;
    this.membro.senha = this.membroForm.value.senha;
    this.membro.senhaConfirmacao = this.membroForm.value.senhaConfirmacao;

    // TODO: ENVIAR FORMULARIO
    this.fidelidadeService
      .atualizarMembroSenha(this.tokenUrl, this.membro)
      .subscribe(
        (sucesso) => {
          this.processarSucessoUpdate(sucesso);
        },
        (falha) => {
          this.processarFalhaUpdate(falha);
        }
      );
  }

  public validarIgualdadeSenhas(): boolean {
    let result = false;

    if (this.membroForm.value.senha != this.membroForm.value.senhaConfirmacao) {
      result = true;
    }

    this.exibeMensagemSenha = result;

    return result;
  }

  public voltarParaHome(): void {
    this.router.navigate(['/']);
  }
}
